import React, { useState } from "react";
import { Col, Container, Row, Carousel } from "react-bootstrap";
import { testimonialData, portfolioData } from "./comon/data";

const Works = () => {
    const [portfolio, setPortfolio] = useState<any>(portfolioData);
    const [categories, setCategories] = useState("all");
    let newportfolio: any = [];

    const filterData = (value: any) => {
        setCategories(value);
        if (value === "all") {
            setPortfolio(portfolioData)
        } else {
            portfolioData?.map((data: any) => {
                return data.category?.filter((Categoty: any) => {
                    if (Categoty === value) {
                        newportfolio.push(data)
                        setPortfolio(newportfolio)
                    }
                    return data;
                })
            })
        }
    }

    return (
        <React.Fragment>
            <section className="section bg-white pb-0" id="portfolio">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <div className="text-center">
                                <h4 className="title-heading text-uppercase">Our Portfolio</h4>
                                <p className="title-desc text-muted mt-3">Huge collection of elements, rich customization options, flexible layouts, stunning pages and instant results!</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col lg={12}>
                            <div className="text-center">
                                <ul className="col container-filter categories-filter list-unstyled mb-0 gap-1 d-flex justify-content-center" id="filter">
                                    <li><a href="#!" className={`${categories === "all" ? "active" : ""} categories`} onClick={() => filterData("all")}>All</a></li>
                                    <li><a href="#!" className={`${categories === "profile" ? "active" : ""} categories`} onClick={() => filterData("profile")}>Profile</a></li>
                                    <li><a href="#!" className={`${categories === "business" ? "active" : ""} categories`} onClick={() => filterData("business")}>Business</a></li>
                                    <li><a href="#!" className={`${categories === "finance" ? "active" : ""} categories`} onClick={() => filterData("finance")}>Finance</a></li>
                                    <li><a href="#!" className={`${categories === "marketing" ? "active" : ""} categories`} onClick={() => filterData("marketing")}>Marketing</a></li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className="container-grid row-cols-lg-4 row-cols-1 mt-5 g-0 projects-wrapper">
                        {
                            (portfolio || [])?.map((portfolio: any, index: number) => (
                                <Col className="img-max-width" key={index}>
                                    <div className="item-box">
                                        <a className={`cbox-gallary${index} mfp-image`} href="#!" title="Project Name">
                                            <img className="item-container img-fluid profile business" src={portfolio.imageUrl} alt="1" />
                                            <div className="item-mask">
                                                <div className="item-caption">
                                                    <h5 className="text-dark">{portfolio.title}</h5>
                                                    <p className="text-muted">client: Kay Garland</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </section>
            <section className="section" id="client">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={7}>
                            <div className=" text-center">
                                <h4 className="title-heading text-uppercase">Testimonial</h4>
                                <p className="title-desc text-muted mt-3">We craft digital, graphic and dimensional thinking, to create category leading brand experiences that have meaning and add a value.</p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center mt-4" >
                        <Col lg={8}>
                            <Carousel id="owl-demo">
                                {(testimonialData || []).map((testimonial: any) => {
                                    return (
                                        <Carousel.Item key={testimonial.id}>
                                            <div className="testi-box">
                                                <div className="text-center mt-4">
                                                    <div className="testi-content">
                                                        <p className="user-review text-center mb-0">
                                                            {testimonial.review}
                                                        </p>
                                                    </div>
                                                    <div className="mt-4">
                                                        <img
                                                            src={testimonial.image}
                                                            alt=""
                                                            className="img-fluid rounded-circle testi-user mx-auto d-block"
                                                        />
                                                    </div>
                                                    <div className="img-post text-center">
                                                        <p className="testi-patients text-muted mb-1 mt-3">
                                                            {testimonial.designation}
                                                        </p>
                                                        <h5 className="testi-client-name">{testimonial.name}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </Carousel.Item>
                                    )
                                })}
                            </Carousel>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Works;